import { HttpClient } from '@angular/common/http';
import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject, finalize, map } from 'rxjs';
import { DialogService } from 'src/app/utils/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatoriService } from './operatori.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { FunctiiService } from '../functii/functii.service';
import Swal from 'sweetalert2';
import { EditOperatorComponent } from './edit-operator/edit-operator.component';
import { PermissionsService } from '../../../services/permissions.service';
import { UpdateFunctieOperatorComponent } from './update-functie-operator/update-functie-operator.component'
import { FormControl, FormGroup } from '@angular/forms';
import { UsersService } from 'src/app/services/users.service';
import { Generic, GenericUser } from 'src/app/interfaces/generic.interface';
import { CereriService } from 'src/app/components/cereri/cereri.service';
import { DirectiiService } from 'src/app/services/directii.service';
@Component({
    selector: 'app-operatori',
    templateUrl: './operatori.component.html',
    styleUrls: ['./operatori.component.scss'],
})
export class OperatoriComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    isFilterLoading = false;
    showCard = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    functiiMap: { [key: number]: string } = {};
    names!: GenericUser[];
    functii!: Generic[];
    directii!: Generic[];
    compartimenteActive$!: Observable<Generic[]>;

    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    defaultNameParameter: { name: string; id_user: string } = {
        name: 'Toate',
        id_user: '-1',
    };

    dtLink =
        environment.interop.basePath +
        environment.interop.urbanism.nomenclatoare.operatori.getOperatoriDT;

    //Form Initial Values

    searchParamsForm!: FormGroup;

    initialFormValues = {
        name: '',
        functie: '-1',
        directie: '-1',
        compartiment: '-1',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            name: new FormControl(''),
            functie: new FormControl('-1'),
            directie: new FormControl('-1'),
            compartiment: new FormControl('-1'),
        });
    }


    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private operatoriService: OperatoriService,
        private functiiService: FunctiiService,
        public permissionsService: PermissionsService,
        private usersService: UsersService,
        private cereriService: CereriService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
        this.getFunctii();
        this.buildSearchParamsForm();
        this.loadFilteringElements();
    }


    toggleCard() {
        this.showCard = !this.showCard;
    }

    loadFilteringElements() {
        // this.loadNames();
        this.loadDirectiiActive();
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        console.log('apply');
        this.showCard = false;
        this.rerenderDT();
    }

    loadDirectiiActive() {
        this.isFilterLoading = true;
        this.cereriService
            .getDirectii()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.directii = results;
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.isFilterLoading = false;
                },
            });
    }

    getFunctii() {
        this.functiiService.getMappedFunctii().subscribe((data) => {
            this.functii = [this.defaultParameter, ...data];
            data.forEach((item) => {
                this.functiiMap[item.id] = item.name;
            });
        });
    }

    // loadNames() {
    // 	this.isFilterLoading = true;
    // 	this.usersService
    // 	  .getUsersActive()
    // 	  .pipe(
    // 		map((results: any) => [this.defaultNameParameter, ...results.data]),
    // 		finalize(() => (this.isFilterLoading = false))
    // 	  )
    // 	  .subscribe({
    // 		next: (results) => {
    // 		  this.names = results;
    // 		},
    // 		error: (error) => {
    // 		  console.error('Error loading names', error);
    // 		  this.isFilterLoading = false;
    // 		},
    // 	  });
    //   }

    onDirectieChange(directieId: number): void {
        if (directieId) {
            this.loadCompartimenteActive(directieId);
        } else {
            this.compartimenteActive$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: '--Alegeți--', id: -1 }]);
                observer.complete();
            });
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isFilterLoading = true;
        let compartimenteObservable$ = directieId
            ? this.cereriService.getCompartimenteByDirectieId(directieId)
            : this.cereriService.getCompartimenteActive();

        this.compartimenteActive$ = compartimenteObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        );
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            responsive: true,
            searching: false,
            serverSide: true,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.filters = this.searchParamsForm.value;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id_user',
                },
                {
                    title: 'Nume',
                    data: 'name',
                },
                {
                    title: 'Funcție',
                    data: 'functie_id',
                    render: (data: any) => this.functiiMap[data] || 'N/A',
                },
                {
                    title: 'Compartiment',
                    data: 'denumire_sesizare_compartiment',
                    render: function (data: any) {
                        return data === null || data === undefined ? 'N/A' : data;
                    },
                },
                {
                    title: 'Instituție',
                    data: 'denumire_sesizare_departament',
                    render: function (data: any) {
                        return data === null || data === undefined ? 'N/A' : data;
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: (row: any) => {
                        return `
							<button type="button" class="action-btn edit ms-1" title="Editare">
							<img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
							</button>
							<button class="action-btn signatures ms-1" title="Actualizare funcție">
                				<img class="btn-img" src="/assets/icons/simple-signature-contract.svg" alt="signatures"/>
              				</button>

						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;

                const signaturesIcon = lastTd?.querySelector(
                    '.signatures'
                ) as HTMLElement;


                if (editIcon) {
                    if (!this.permissionsService.hasPermission('urbanism-module.settings.operatori.update')) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (signaturesIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'urbanism-module.settings.template-documente.actualizare-semnatari'
                        )
                    ) {
                        signaturesIcon.style.display = 'none';
                    }
                    signaturesIcon.addEventListener('click', () => {
                        this.openUpdateFunctieOperator(data);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        console.log('rerender');
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(resetPaging);
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditOperatorComponent, {
            minHeight: '80vh',
            maxHeight: '80vh',
            minWidth: '50vw',
            maxWidth: '80vw',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Actualizare cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openUpdateFunctieOperator(data: any) {
        const dialogRef = this.dialog.open(UpdateFunctieOperatorComponent, {
            maxHeight: '40vh',
            minWidth: '50vw',
            maxWidth: '90vw',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            this.rerenderDT();
            if (success) {
                this.isLoading = true;
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Actualizare cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }
}
